export const productName = 'GEOLOGY COMPLETE TEACHING RESOURCE COLLECTION';
export const productImage =
  'https://cdn.magicpatterns.com/uploads/p8NCrutWELCtZg59c2XrBj/geology-bundle-1x1-transparent.png';

export const checkoutUrl = 'https://geology.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const included = [
  'Volume 1 — Geology Fundamentals & Earth Systems',
  'Volume 2 — Minerals, Crystals & The Rock Cycle',
  'Volume 3 — Plate Tectonics, Earthquakes & Volcanoes',
  'Volume 4 — Sedimentology, Stratigraphy & Geological Time',
  'Volume 5 — Paleontology & The Evolution of Life',
  'Volume 6 — Structural Geology & Geological Mapping',
  "Volume 7 — Geomorphology, Soils & Earth's Landscapes",
  'Volume 8 — Applied, Environmental & Economic Geology',
  'Volume 9 — Teaching Geology: Lesson Planning & Projects',
  'Bonus 1 — 150 Geology Classroom Activities',
  'Bonus 2 — 60 Assessment Instruments',
  'Bonus 3 — 50 Projects & STEM Challenges',
  'Bonus 4 — 500 Concepts & Terminology Guide',
  'Bonus 5 — 100 Global Case Studies',
  '7-day money-back guarantee',
  'Instant access',
];

export const systemNegatives = [
  "It's not outdated theory copied from old textbooks.",
  "It's not a collection of disconnected activities.",
  "It's not material you'll need to completely rewrite.",
];

export const closingLines = [
  'No more sleepless nights searching for ways to explain complex geological processes',
  "No more rushed lessons with materials that don't work",
  "No more disconnected students who don't see geology's relevance",
  'No more weekends spent building lesson plans from scratch',
  "No more awkward silences when students ask technical questions you weren't ready for",
];
